import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";

export default function Hero() {
  return (
    <Box
      sx={{
        bgcolor: "#009748", // white background
        py: { xs: 4, md: 8 }, // vertical padding
        height: 135,
        textAlign: "center", // center the text
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        pl: { xs: 2, md: 0 },
        pr: { xs: 2, md: 0 },
        pt: { xs: 10, md: 9 },
        pb: { xs: 35, md: 15, lg: 9 },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{ textAlign: "center", alignItems: "center" }}
      >
        <Typography
          variant="h4"
          fontFamily={"Roboto, sans-serif"}
          sx={{
            color: "white",
            fontWeight: "bold",
            mt: -7,
            fontSize: { xs: "1.5rem", md: "2.15rem" },
          }}
        >
          Where Quality Meets Service
        </Typography>

        <Typography
          variant="body1"
          fontFamily={"Roboto, sans-serif"}
          sx={{
            color: "white",
            mt: 1,
            alignItems: "center",
            textAlign: "center",

            fontSize: { xs: "0.8rem", md: "1rem" },
          }}
        >
          Natureall supplies a range of foods, beverages and cleaning materials
          from our distribution centres in Johannesburg, Cape Town and Durban.
          Our focus is to provide competitively priced, wholesome, delicious and
          quality food and beverage products. Our cleaning materials are high
          quality and cost effective products that get the job done. Some
          products are manufactured on demand to ensure maximum freshness,
          quality and shelf life. Our product range focuses on a variety of
          sizes from retail packs to larger commercial, catering and food
          service packs. Our pack sizes typically range from 500g to 25Kg or
          500ml to 25L variants. We can also produce customised pack sizes and a
          variety of flavour variants based on volume requirements. Our foods,
          beverages and cleaning divisions are manufactured in separate
          facilities offering a wide range of products.
          <br />
          <br />
          {/* We distribute our products via reputable distributors in various
          market sectors and distribution channels. Should you wish to enquire
          about our products, want to find your closest distributor partner or
          wish to apply to become a distributor, please contact our head office
          in Johannesburg */}
        </Typography>
        <Button
          variant="contained"
          sx={{
            alignItems: "center",
            mt: -2,
            backgroundColor: "#ee8712ff",
            color: "#ffffffff",
            fontWeight: "auto",
            "&:hover": {
              backgroundColor: "#f19429ff",
            },
          }}
          href="mailto:sales@natureall.co.za"
        >
          Contact Us
        </Button>
      </Container>
    </Box>
  );
}
